import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import styled from "styled-components";
import { BoldHeader2, Text } from "src/apps/components/typography/Texts";
import { T } from "src/apps/components/i18n/Translation";
import { useTheme } from "src/apps/providers/ThemeStore";
import { OrderIdentityVerification } from "src/contexts/documentationArea/domain/OrderIdentityVerification";

import { colors } from "@permisso/permisso-components";

interface IDVStatefulOrdersSectionHeaderProps {
  title: string;
  description: string;
  order: OrderIdentityVerification;
}

export const IDVStatefulOrdersSectionHeader = ({
  title,
  description,
  order,
}: IDVStatefulOrdersSectionHeaderProps) => {
  const { successColor, errorColor } = useTheme();

  const isCompleted = order.hasValidResponses();
  const hasErrors = order.hasResponses() && !order.hasValidResponses();

  return (
    <Content>
      <Header>
        {isCompleted ? (
          <Icon size={ICON_SIZES.s20} color={successColor} path={ICON_PATHS.CHECK_CIRCLE_THIN} />
        ) : hasErrors ? (
          <Icon size={ICON_SIZES.s20} color={errorColor} path={ICON_PATHS.CROSS_CIRCLE_THIN} />
        ) : null}
        <BoldHeader2>
          <T k={title} />
        </BoldHeader2>
      </Header>
      {description ? (
        <Text $color={colors.grey700}>
          <T k={description} />
        </Text>
      ) : null}
    </Content>
  );
};

const Header = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.5rem;
`;

const Content = styled.div`
  display: flex;
  padding: 1.75rem;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.5rem;
`;
